import { COUNTRIES_WITHOUT_USERCENTRICS, USERCENTRICS_CONFIGURATION } from './constants';

export function isCookieBannerDisabled(countryId: number): boolean {
  return COUNTRIES_WITHOUT_USERCENTRICS.includes(countryId);
}

export function getUsercentricsScriptProps(language: string) {
  return {
    id: 'usercentrics-cmp',
    key: 'usercentricsCmp',
    defer: true,
    'data-settings-id': USERCENTRICS_CONFIGURATION.settingsId,
    'data-language': language,
    src: USERCENTRICS_CONFIGURATION.paths.bundle,
  };
}
